
import AppProviders from "@/components/app/AppProviders";
import AppRoutes from "@/components/app/AppRoutes";
import { OnboardingModal } from "@/components/onboarding/OnboardingModal";

function App() {
  return (
    <AppProviders>
      <AppRoutes />
      <OnboardingModal />
    </AppProviders>
  );
}

export default App;
